import { render } from "./ProductReview.vue?vue&type=template&id=40ff6070"
import script from "../js/product-review.js?vue&type=script&lang=js&external"
export * from "../js/product-review.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__